export default __webpack_public_path__ + "static/media/salary.a3910ee9.png";